import { IVisitorInformation, IVisitorProvider } from 'core/model/interfaces/visitor.interface';
import { getAppInstanceIdOrEmptyAndInitialize } from 'core/utils/app-instance-id.utils';

export class FingerprintProvider implements IVisitorProvider {
  private readonly id: string | null;

  constructor() {
    this.id = getAppInstanceIdOrEmptyAndInitialize();
  }

  async getInformation(): Promise<IVisitorInformation> {
    return { id: this.id };
  }
}
